import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

/**
 * Enables admixtures product type by country
 */
@Injectable()
export class EnableAdmixturesProductTypeFeature implements IFlagFeature {
  name = Features.ENABLE_ADMIXTURES_PRODUCT_TYPE;

  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].isEnabled();
  }
}
